/* eslint-disable prettier/prettier */
import { Auth } from '@aws-amplify/auth';

let cookieDomain = 'listwithclever.com';
if (process.env.NODE_ENV === 'development') {
  cookieDomain = 'localhost';
} else if (String(process.env.NODE_ENV) === 'staging') {
  cookieDomain = '.listwithclever.com'; // Use .listwithclever.com to work with subdomains
}

const cookieStorage = {
  domain: cookieDomain,
  secure: true,
  path: '/',
  expires: 365, // expires in days
  sameSite: 'none',
};

const userPoolId = process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID;
const userPoolWebClientId =
  process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID;

Auth.configure({
  region: process.env.REACT_APP_AWS_AMPLIFY_REGION,
  userPoolId,
  userPoolWebClientId,
  mandatorySignIn: true,
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  cookieStorage,
});
